import { Suspense } from 'react';
import { LazyBoundary } from '~portal/components/common/LazyBoundary';
import { Cmp, retryableLazy } from '~portal/lib';
import type { AdminNavPanelProps } from './AdminNavPanel';

/**
 * @desc The admin tree, its icons and the Ario connection line reach admins only, and only once
 * the column folds over to the admin state, so the panel is a lazy island rather than part of
 * the entry chunk (docs/code-splitting.md). Until its chunk lands the column stays empty under
 * the logo; a chunk that fails even after its retry shows the island's Reload line.
 */
const AdminNavPanel = retryableLazy(() =>
  import('./AdminNavPanel').then((module) => ({ default: module.AdminNavPanel })),
);

export const LazyAdminNavPanel: Cmp<AdminNavPanelProps> = function (props) {
  return (
    <LazyBoundary name="AdminNavPanel">
      <Suspense fallback={null}>
        <AdminNavPanel {...props} />
      </Suspense>
    </LazyBoundary>
  );
};
